module.exports = __webpack_public_path__ + "img/project.b6d083be.png";